import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import AttendanceRankingList from '../../Model/Individual/StatisticsModel/AttendanceRankingList';

import IntroMarkdown from './IntroMarkdown';

export default function AttendanceRankingListRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const { intro, ranking, startDate, month } = data;

  // 산정기간 표시 텍스트 계산 //
  function calcDateText() {
    const target = month ? moment(month + '-01T00:00:00') : (startDate ? moment(startDate) : moment());

    return target.format(t('statistics.dateFormatMonth'));
  }

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ListContainer $bg={theme.subBackground}>
        <AttendanceRankingList
          data={ranking || []}
          selectedPartnerGym={undefined}
          calcDateText={calcDateText} />
      </ListContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 100%;

  padding: 16px;

  border-radius: 10px;
  background-color: ${props => props.$bg};

  overflow-x: auto;

  box-sizing: border-box;
`;
